import { render, staticRenderFns } from "./PriceBooster.vue?vue&type=template&id=6d10ef3a&scoped=true&"
import script from "./PriceBooster.vue?vue&type=script&lang=js&"
export * from "./PriceBooster.vue?vue&type=script&lang=js&"
import style0 from "./PriceBooster.vue?vue&type=style&index=0&id=6d10ef3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d10ef3a",
  null
  
)

export default component.exports